<template>
  <TransactionListTemplate
    :screenConfig="screenConfig"
    :setLoading="isLoading"
    ref="grower-ready-list"
    persistence-key="cracking-run-grower-ready"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "@/templates/transaction-list";
import {
  CrackingRunTabs,
  GetIndexByTabName,
} from "@/_models/tabdata/inventory/cracking-run";
import { CrackingRunGrowerReadyService } from "@/_services/api/inventory/cracking-run-grower-ready.service";
import ColumnWidth from "../../../_helpers/data-grid/ColumnWidth";
import { FeatureStorage } from "../../../_services/storage";
// import { mapGetters } from "vuex";

export default {
  mixins: [RouteMixin, FormMixin],
  components: { TransactionListTemplate },

  data() {
    return {
      isLoading: false,
    };
  },
  created() {
    // this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
  },
  beforeRouteLeave(to, from, next) {
    // this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    next();
  },

  computed: {
    // ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    screenConfig() {
      return {
        title: "Cracking Run",
        selectedIndex: GetIndexByTabName("Grower Ready"),
        tabs: CrackingRunTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoReportSummaryCrackingDataExInshell",
              filter: [], // set by filter panel
              serverPaging: true, // do client-side paging to preserve selection across virtual scroll pages
              allowGrouping: false,
              select: [
                "ParentRunNumber",
                "SeasonYear",
                "DateCreated",
                "GrowerName",
                "GrowerCode",
                "VarietyCode",
                "VarietyName",
                "RunNumbers",
                "DepotDockets",
                "KernelWeight",
                "NetWeight",
                "WasteWeight",
                "StickWeight",
                "IsReadyForGrower",
              ],
            },
            options: {
              dxPaging: true,
              pageSize: 100,
              allowedPageSizes: [50, 100, 200],
              selectionMode: "multiple",
              allowSelectAll: true,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No records found",
                message: "Select a season and click Refresh to load data.",
              },
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  visible: FeatureStorage.checkPermission(
                    "CrackingRunGrowerReady",
                    "create",
                  ),
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Make Ready",
                    },
                    {
                      menuText: "Make Not Ready",
                    },
                  ],
                  onItemClick: (e) => {
                    this.onChangeGrowerReady(e);
                  },
                },
              },
            ],
          },

          columns: [
            // ── Visible table columns ──
            {
              screenField: "DateIn",
              dataField: "DateCreated",
              label: "Run Date",
              sortOrder: "desc",
              sortIndex: 0,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              filterIndex: 5,
              filterLabel: "Run date",
              filterDataField: "DateCreated",
            },
            {
              dataField: "ParentRunNumber",
              label: "Parent run",
              width: 110,
            },
            {
              screenField: "Supplier",
              dataField: "GrowerName",
              label: "Grower",
              calculateSortValue: "GrowerName",
              cellTemplateRecord: {
                primary: [{ dataField: "GrowerName" }],
                secondary: [{ dataField: "GrowerCode" }],
              },
              exportFields: [
                { dataField: "GrowerName", label: "Grower Name" },
                { dataField: "GrowerCode", label: "Grower Code" },
              ],
              filterIndex: 2,
              filterLabel: "Grower",
              filterDataField: "GrowerCode",
              allowHiding: false,
              multiSelect: false,
            },
            {
              screenField: "Variety",
              dataField: "VarietyCode",
              dataSourceConfig: {
                endpoint: "api/AlmondcoReportSummaryCrackingVariety",
                sort: {
                  selector: "VarietyName",
                  asc: true,
                },
              },
              filterDataField: "VarietyCode",
              label: "Var.",
              width: 120,
              filterIndex: 3,
              multiSelect: false,
            },
            {
              dataField: "RunNumbers",
              label: "Runs",
              minWidth: 100,
              allowSorting: false,
            },
            {
              dataField: "DepotDockets",
              label: "Dockets",
              minWidth: 140,
              allowSorting: false,
            },
            {
              dataField: "KernelWeight",
              label: "Kernel kg",
              dataType: "number",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              format: "###,###,##0.00",
              cellTemplate: "Decimal",
            },
            {
              dataField: "NetWeight",
              label: "Field Wgt kg",
              dataType: "number",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              alignment: "right",
              format: "###,###,##0.00",
              cellTemplate: "Decimal",
            },
            {
              dataField: "WasteWeight",
              label: "Waste kg",
              dataType: "number",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              alignment: "right",
              format: "###,###,##0.00",
              cellTemplate: "Decimal",
            },
            {
              dataField: "StickWeight",
              label: "Sticks kg",
              dataType: "number",
              width: ColumnWidth.Quantity2DecimalPoints.width,
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              alignment: "right",
              format: "###,###,##0.00",
              cellTemplate: "Decimal",
            },
            {
              dataField: "CrackOutPercent",
              label: "Crack out%",
              dataType: "number",
              width: 105,
              alignment: "right",
              allowSorting: false,
              format: "###,###,##0.00",
              calculateCellValue: (row) => {
                if (!row.NetWeight) return 0;
                return (
                  (row.KernelWeight /
                    (row.NetWeight + row.StickWeight + row.WasteWeight)) *
                  100
                );
              },
              cellTemplate: "Decimal",
            },

            // ── Filter-panel fields (filterIndex drives right-panel order) ──
            {
              screenField: "FiscalYearSelect",
              // filterDefaultValue: "CurrentFiscalYear",
              filterDataField: "SeasonYear",
              label: "Season",
              filterLabel: "Season",
              filterIndex: 1,
              visible: false,
              showInColumnChooser: false,
              multiSelect: false,
            },
            {
              screenField: "Status",
              dataField: "IsReadyForGrower",
              filterDataField: "IsReadyForGrower",
              filterIndex: 4,
              showInColumnChooser: false,
              dataSourceConfig: {
                data: [
                  { value: "Y", IsReadyForGrower: "Ready" },
                  { value: "N", IsReadyForGrower: "Not ready" },
                ],
              },
              valueExpr: "value",
              displayExpr: "IsReadyForGrower",
              visible: false,
              dataType: "boolean",
              multiSelect: false,
            },
            {
              // screenField: "OrderStatus",
              label: "Grower Ready?",
              dataField: "IsReadyForGrower",
              cellTemplate: "StatusYesNo",
              allowSorting: false,
              width: 120,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Make Ready",
                      data: data,
                      visible: data.data.IsReadyForGrower !== "Y",
                      clickAction: this.onSaveReady.bind(this),
                    },
                    {
                      menuText: "Make Not Ready",
                      data: data,
                      visible: data.data.IsReadyForGrower !== "N",
                      clickAction: this.onSaveNotReady.bind(this),
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return FeatureStorage.checkPermission(
                  "CrackingRunGrowerReady",
                  "create",
                )
                  ? false
                  : true;
              },
            },
          ],
        },
      };
    },
  },

  methods: {
    async onChangeGrowerReady(e) {
      const selectedData =
        this.$refs[
          "grower-ready-list"
        ].$refs.transactionListGrid.selectedRowData();
      if (!selectedData || selectedData.length === 0) {
        await this.$alert(
          "Please select at least one cracking run to update grower ready status.",
          "No runs selected",
        );
        return;
      }

      if (!e || !e.event || !e.itemData) return;

      const makeReady = e.itemData.menuText === "Make Ready";

      const payload = selectedData.map((row) => ({
        ParentRunNumber: row.ParentRunNumber,
        SeasonYear: row.SeasonYear,
        IsReadyForGrower: makeReady,
      }));

      this.onSave(payload);
    },

    onSaveReady(e) {
      const payload = [
        {
          ParentRunNumber: e.ParentRunNumber,
          SeasonYear: e.SeasonYear,
          IsReadyForGrower: true,
        },
      ];

      this.onSave(payload, false);
    },
    onSaveNotReady(e) {
      const payload = [
        {
          ParentRunNumber: e.ParentRunNumber,
          SeasonYear: e.SeasonYear,
          IsReadyForGrower: false,
        },
      ];

      this.onSave(payload, false);
    },

    async onSave(payload, deselectAll = true) {
      if (!navigator.onLine) {
        this.$notify(
          "No network connection. Please check your internet and try again.",
          "error",
        );
        return;
      }

      const grid = this.$refs["grower-ready-list"].$refs.transactionListGrid;
      if (!grid) {
        return;
      }

      const gridInstance = grid.getDataSourceInstance();

      this.isLoading = true;
      try {
        await CrackingRunGrowerReadyService.save(payload);
        this.isLoading = false;
        this.$notify("Grower ready status saved successfully", "success");
        if (deselectAll) {
          gridInstance.deselectAll();
        }

        this.$nextTick(() => {
          grid.gridRepaint();
        });
      } catch (err) {
        this.isLoading = false;
        this.displayServerError(err, "Save failed");
        // Always show error notification if status is not 200
        if (!err || (err.status && err.status !== 200)) {
          this.$notify("Save failed", "error");
        }
      }
    },
  },
  watch: {
    // getHotKeySave(newVal) {
    //   if (newVal) {
    //     this.$store.dispatch("hotKey/setHotKeySave", false);
    //     this.onChangeGrowerReady();
    //   }
    // },
  },
};
</script>

<style lang="scss">
.grower-save-button {
  background-color: #03a9f4 !important;
  color: #fff !important;

  height: 25px;
  .dx-button-content {
    padding: 3px;
  }
  .dx-icon {
    font-size: 12px;
    margin-right: 0px;
    padding: 0px;
    // margin-top: 2px;
  }
  .dx-button-text {
    font-size: 10px;
  }
}
</style>
